<template>
  <div class="ai-realproject">
    <div class="title">
      <h2>全部项目</h2>
    </div>
    <div class="list" v-if="itemData.length > 0">
      <div class="item-parent">
        <div
          style="width: 340px"
          id="index"
          v-for="(value, index) in itemData"
          :key="index"
        >
          <div
            class="item-child"
            @click="goDetails(value)"
            v-track="[value.name, '文字点击']"
          >
            <div class="divImg">
              <img src="@/assets/cover.jpg" v-if="!value.logoImage" />
              <img
                v-lazy="{
                  src: value.logoImage.url,
                  loading: require('@/assets/coverpic.jpg'),
                }"
                v-else
              />
              <div class="box-sha">
                <div @click="goDetails(value)" class="go-detail">
                  <span>查看详情</span>
                </div>
              </div>
            </div>
            <!-- 底部文字部分 -->
            <div class="hover-div">
              <div class="bottom-word">
                <div class="hover-div-header">
                  <p>{{ value.name }}</p>
                  <div v-if="value.baseInfoTitle1" class="label1">
                    {{ value.baseInfoTitle1 }}
                  </div>
                  <div v-if="value.baseInfoTitle2" class="label2">
                    {{ value.baseInfoTitle2 }}
                  </div>
                </div>

                <div class="list-word">
                  <ul>
                    <li>
                      <article
                        class="context"
                        v-html="getMarkedData(value.indexPageDescription)"
                      ></article>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Contents } from '../../../../../gqlapi/Contents.js';
import marked from 'marked';
export default {
  data() {
    return {
      itemData: [],
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 26,
        slidesPerGroup: 2,
        loop: false,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          disabledClass: 'swiper-button-disabled-class',
        },
      },
    };
  },
  created() {
    this.getList('8');
  },
  methods: {
    goDetails(value) {
      // this.$trackEvent(value.name, '点击项目', value.name)
      window.sessionStorage.setItem('detailsId', String(value.id));
      let routerData;
      if (value.router) {
        routerData = this.$router.resolve({
          path: value.router,
        });
      } else if (value.p_template && value.p_template.code) {
        routerData = this.$router.resolve({
          path: '/' + value.p_template.code,
        });
      }
      window.open(routerData.href, '_blank');
    },
    getList(ids) {
      // this.$apollo
      //   .query({
      //     query: Contents,
      //     variables: {
      //       subjectID: ids,
      //       isPublish: true,
      //     },
      //   })
      this.$axios
        .post('/api', {
          operationName: 'Contents',
          variables: {
            subjectID: ids,
            isPublish: true,
          },
          query: Contents,
        })
        .then((res) => {
          this.itemData = res.data.data.pContents;
        })
        .catch(() => {});
    },
    getMarkedData(value) {
      return marked(value || '', {
        sanitize: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-realproject {
  background-color: #f4fafe;
  // margin-top: 100px;
  padding-bottom: 30px;
  .title {
    h2 {
      font-weight: bold;
    }
  }
}
.ai-detail {
  width: 620px;
  height: 21px;
  margin: 0px auto;
  padding: 20px 0;
  padding-left: 30px;
  box-sizing: border-box;
  display: flex;
  height: 17px;
  font-size: 12px;
  font-family: 'PingFangSC', 'MicrosoftYaHei', 'PingFangSC-Semibold';
  text-align: left;
  color: #616a72;
  line-height: 17px;
  text-align: center;
  .item {
    font-size: 16px;
    color: #616a72;
    cursor: pointer;
    border-right: 1px solid #dee1e5;
    padding-right: 16px;
    padding-left: 16px;
    &:first-child {
      padding-left: 0px;
    }
    &:last-child {
      padding-right: 0px;
    }
  }
}
.item-parent {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .item-child {
    margin-bottom: 30px;
    max-height: 340px;
    border-radius: 8px;
    .divImg {
      border-radius: 8px 8px 0 0;
      .go-detail {
        left: 50% !important;
        transform: translateX(-60px);
      }
    }
    .hover-div {
      .bottom-word {
        p {
          font-weight: bold;
          border-bottom: none !important;
          color: #19232b;
          padding-bottom: 10px !important;
        }
        .list-word {
          margin-top: 0px !important;
          :deep(ul li h4) {
            line-height: 24px;
            color: #616a72;
            margin-top: 0px !important;
          }
          :deep(ul li) {
            margin-top: 0px !important;
          }
        }
      }
    }
  }
}
.ai-home .ai-realproject .list {
  width: 1440px;
  padding-top: 50px;
}
.ai-home .ai-realproject {
  padding-top: 70px;
}
.ai-home .ai-realproject .list .item-parent .item-child:hover {
  background-color: white;
  // transition: all 0.8s;
  // transform: scale(1.03);
}
.ai-home .ai-realproject .list .item-parent .item-child .divImg img {
  height: 190px;
}
.ai-home .ai-realproject .list .item-parent .item-child .divImg .box-sha {
  height: 192px;
}
.ai-home .ai-realproject .list .item-parent .item-child .hover-div .bottom-word,
.ai-home
  .ai-realproject
  .list
  .item-parent
  .item-child
  .hover-div
  .bottom-word
  .list-word {
  width: auto;
}
.hover-div-header {
  display: flex;
  align-items: center;
  p {
    margin-right: 10px;
  }
  .label1 {
    margin-right: 10px;
  }
  .label1,
  .label2 {
    height: 18px;
    background: #ffffff;
    border: 1px solid #1086ff;
    border-radius: 18.6px;
    width: auto;
    color: #1086ff;
    padding: 3px 5px;
    margin-bottom: 15px;
    font-size: 12px;
    text-align: center;
    line-height: 18px;
  }
}
</style>
